<ng-container>
    <div class="Flexbox Flexbox__box-direction-column-reverse open-close-panel pointer"
         *ngIf="filterAdminMode || !isFilterPanelOpened"
         (click)="toggleFilterPanel()">
        <div class="icon-wrapper">
        <span *ngIf = "!filterAdminMode"
              [ngClass]="isFilterPanelOpened ? 'icon__filter-expand btn-filter' : 'icon__filter-expand btn-filter'"
              class="Flexbox__align-self-center">
        </span>
        </div>
    </div>
    <gen-panel [ngClass]="{'not-full-panel':!isFullScreen && !isFilterPanelOpened}"
            class="filter-gen-panel"
            [name]="panelName"
            (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)"
    >
    </gen-panel>
</ng-container>
